import React from 'react';
import './ConnectionLabel.css';

interface ConnectionLabelProps {
  label: string;
  position: { x: number; y: number };
  angle?: number;
}

const ConnectionLabel: React.FC<ConnectionLabelProps> = ({ label, position, angle = 0 }) => {
  return (
    <div
      className="connection-label"
      style={{
        left: position.x,
        top: position.y,
        transform: `translate(-50%, -50%) rotate(${angle}deg)`,
      }}
    >
      {label}
    </div>
  );
};

export default ConnectionLabel;
